export default __webpack_public_path__ + "static/media/edit.d068b7b1.svg";